module.exports = __webpack_public_path__ + "media/images/search_ico-194a8367.svg";